/**
 * @generated SignedSource<<908032bfe3bd31eebe0b570cd5e0459c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotesItemFragment$data = {
  readonly addedByUser: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarWithDetailsFragment">;
  };
  readonly body: string | null;
  readonly createdAt: string;
  readonly id: string;
  readonly " $fragmentType": "UserNotesItemFragment";
};
export type UserNotesItemFragment$key = {
  readonly " $data"?: UserNotesItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserNotesItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserNotesItemFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "addedByUser",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileAvatarWithDetailsFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNote",
  "abstractKey": null
};
})();

(node as any).hash = "bf20bc2aecc01cd8a2a6fa9d85834dc7";

export default node;
